import React from 'react'

export default function GameDetailsFooter({game, onClose, onNoShow, onCancel, onConfirm}) {
  const cancelTitle = 'Cancel ' + (game.special_event ? 'event' : 'reservation')
  const noShowText = game.no_show ? 'Undo No Show' : 'No Show'

  return <div className='row'>
    <div className='col-xs-3'>
      { !game.cancelled &&
        <a className='btn btn-danger clickable' onClick={onCancel}>{cancelTitle}</a>
      }
    </div>
    <div className='col-xs-7'>
      { !game.approved && 
        <a className='btn btn-success clickable' onClick={onConfirm}>Confirm Reservation</a>
      }
    </div>
    <div className='col-xs-2 text-right'>
      <a className='btn btn-danger clickable' onClick={onNoShow}>{noShowText}</a>
    </div>
  </div>
}
